export default __webpack_public_path__ + "assets/wind-beaufort-9.f68b287e.svg";